const templateTitle = 'Template';

export const ANALYTICS_NAMES = {
  WRAPPER: 'TemplateAssetPage',
  NAVIGATION: 'Navigation',
  BREAD_CRUMB: 'BreadCrumb',
};
export default templateTitle;
